import { MBTI_GROUPS, MBTI_NAMES_PT, MBTI_TEST_URL } from "../profileConstants";

// MBTI type picker grouped by temperament (Analysts/Diplomats/Sentinels/Explorers).
export const MbtiPicker = ({ value, onChange }) => (
  <div>
    <div className="flex items-baseline justify-between mb-2">
      <label className="block text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]">
        Perfil MBTI
      </label>
      <a
        href={MBTI_TEST_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--primary))] hover:underline"
        data-testid="mbti-test-link"
      >
        Fazer o teste ↗
      </a>
    </div>
    <p className="text-[11px] text-[hsl(var(--muted-foreground))] mb-3 leading-relaxed">
      Não sabe o seu? <a href={MBTI_TEST_URL} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--primary))] underline">16personalities.com</a> · grátis · ~12 min em português.
    </p>
    <button type="button" onClick={() => onChange("")}
      className={`mb-3 px-3 py-1.5 text-[11px] uppercase tracking-wider border transition-colors ${
        !value ? "bg-[hsl(var(--primary))] text-white border-[hsl(var(--primary))]" : "border-[hsl(var(--border))] hover:border-[hsl(var(--primary))]"
      }`}
      data-testid="mbti-none">— Sem indicação</button>
    <div className="space-y-3" data-testid="mbti-groups">
      {MBTI_GROUPS.map((g) => (
        <div key={g.key} className="border border-[hsl(var(--border))] p-3" data-testid={`mbti-group-${g.key}`}>
          <div className="flex items-baseline gap-2 mb-2">
            <span className="inline-block w-2 h-2 rounded-full" style={{ background: g.color }} aria-hidden="true" />
            <span className="text-[12px] font-semibold tracking-wide" style={{ color: g.color }}>
              {g.label}
            </span>
            <span className="text-[11px] text-[hsl(var(--muted-foreground))]">— {g.sublabel}</span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-1.5">
            {g.types.map((t) => {
              const active = value === t;
              const name = MBTI_NAMES_PT[t];
              return (
                <button
                  key={t}
                  type="button"
                  onClick={() => onChange(t)}
                  title={`${t} · ${name}`}
                  className="flex flex-col items-center gap-0.5 px-2 py-2.5 border transition-colors leading-tight"
                  style={active
                    ? { background: g.color, color: "white", borderColor: g.color }
                    : { borderColor: "hsl(var(--border))" }}
                  data-testid={`mbti-${t}`}
                >
                  <span className="text-[11px] tracking-wider font-mono">{t}</span>
                  <span className="text-[10px] tracking-wide opacity-90">{name}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  </div>
);
